import styled from '@emotion/styled';

import { colorConstants } from 'config/colorConstants';

export const PPA_SPLIT_SEARCH_WIDTH = {
    DEFAULT: 224,
    FILTER_PANEL: 172,
    /** Simulation toolbar — Figma Toolbar-Sim Input / Search (165px) */
    TOOLBAR: 165,
} as const;

export const StyledPpaSplitSearchGroup = styled.div<{ $width?: number | string }>`
    display: inline-flex;
    align-items: stretch;
    width: ${({ $width }) => (typeof $width === 'number' ? `${$width}px` : $width ?? `${PPA_SPLIT_SEARCH_WIDTH.DEFAULT}px`)};
    height: 32px;
    border-radius: 6px;
    border: 1px solid ${colorConstants.greyAlt};
    background: ${colorConstants.white};
    overflow: hidden;

    &:hover,
    &:focus-within {
        border-color: ${colorConstants.greyAlt};
        box-shadow: none;

        button {
            border-left-color: ${colorConstants.greyAlt};

            .anticon {
                color: ${colorConstants.blackTitle};
            }
        }
    }

    .ppa-split-search-input.ant-input,
    .ppa-split-search-input.ant-input-affix-wrapper {
        flex: 1;
        min-width: 0;
        height: 100%;
        border: none !important;
        box-shadow: none !important;
        border-radius: 6px 0 0 6px;
        padding: 4px 11px;
        font-size: 13px;
        line-height: 22px;
        color: ${colorConstants.blackTitle};
        background: transparent;

        &::placeholder {
            color: ${colorConstants.greyAlt12};
        }

        &:hover,
        &:focus,
        &:focus-within,
        &.ant-input-focused,
        &.ant-input-affix-wrapper-focused {
            border: none !important;
            box-shadow: none !important;
            outline: none !important;
        }

        .ant-input {
            font-size: 13px;
            line-height: 22px;
            color: ${colorConstants.blackTitle};
            background: transparent;

            &::placeholder {
                color: ${colorConstants.greyAlt12};
            }

            &:hover,
            &:focus,
            &.ant-input-focused {
                border: none !important;
                box-shadow: none !important;
                outline: none !important;
            }
        }
    }

    &.simulation-toolbar-search {
        .ppa-split-search-input.ant-input,
        .ppa-split-search-input.ant-input .ant-input {
            font-size: 14px;
            line-height: 22px;
        }
    }
`;

export const StyledPpaSplitSearchButton = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 32px;
    height: 100%;
    border: 0;
    border-left: 1px solid ${colorConstants.greyAlt};
    border-radius: 0 6px 6px 0;
    background: ${colorConstants.white};
    padding: 0;
    cursor: pointer;

    &:hover,
    &:focus,
    &:active {
        border-left-color: ${colorConstants.greyAlt};
        background: ${colorConstants.white};
        outline: none;
    }

    .anticon {
        font-size: 16px;
        line-height: 1;
        color: ${colorConstants.blackTitle};
    }

    &:hover .anticon,
    &:focus .anticon,
    &:active .anticon {
        color: ${colorConstants.blackTitle};
    }
`;
